<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6>เกมทั้งหมด</h6>
    </div>

    <!-- ส่วนค้นหา + ปุ่ม (responsive) -->
    <div class="row mb-3 px-3">
      <!-- Search -->
      <div class="col-12 col-md-6 mb-2">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="ค้นหา Game Code หรือ ชื่อเกมส์..."
          class="form-control"
        />
      </div>

      <!-- Buttons for admin -->
      <div
        class="col-12 col-md-12 d-flex flex-wrap justify-content-center gap-2"
        v-if="role.toLowerCase() === 'admin'"
      >
        <div
          class="col-6 col-sm-4 col-md-4 p-0"
          v-for="btn in buttons"
          :key="btn.type"
        >
          <argon-button
            fullWidth
            color="danger"
            variant="gradient"
            @click="openModal(btn.type)"
            :disabled="loading"
          >
            <template v-if="loading">กำลังโหลด...</template>
            <template v-else>{{ btn.label }}</template>
          </argon-button>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <edit-modal
      @closeModal="handleModalClose"
      :showModal="dataModal"
      :value="{ text: selectedUser.code + '-' + selectedUser.name, color: 'text-dark' }"
      :rtpcode="{ text: selectedUser.code + '-' + selectedUser.name, color: 'text-dark' }"
      :schemaname="{ text: selectedUser.schema_name, color: 'text-dark' }"
      :reeltypeid="{ text: selectedUser.reel_type_id, color: 'text-dark' }"
      :code="{ text: selectedUser.code, color: 'text-dark' }"
      :typeModal="{ text: typeModal, color: 'text-dark' }"
      :allGame="allGame"
    />

    <!-- ตาราง -->
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-1">
          <thead>
            <tr class="text-center">
              <th>No.</th>
              <th @click="sort('code')">Game Code {{ sortBy === 'code' ? '▼' : '▲' }}</th>
              <th @click="sort('name')">ชื่อเกมส์ {{ sortBy === 'name' ? '▼' : '▲' }}</th>
              <th @click="sort('name_th')">ชื่อเกมส์ไทย {{ sortBy === 'name_th' ? '▼' : '▲' }}</th>
              <th @click="sort('rtp_id')">RTP {{ sortBy === 'rtp_id' ? '▼' : '▲' }}</th>
              <th @click="sort('reel_type_id')">Reel Type {{ sortBy === 'reel_type_id' ? '▼' : '▲' }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-if="displayedData.length > 0">
            <tr
              v-for="(item, index) in displayedData"
              :key="item.code"
              :class="['hover-highlight text-center', getClass(item.rtp_id)]"
            >
              <td>{{ index + 1 + startRow }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.name_th }}</td>
              <td>{{ itemValue(item, 'rtp_id') }}</td>
              <td>{{ itemValue(item, 'reel_type_id') }}</td>
              <td>
                <argon-button
                  v-if="role.toLowerCase() === 'admin' && !excludedCodes.includes(item.code)"
                  variant="gradient"
                  color="danger"
                  size="lg"
                  @click="openModal(0, item)"
                >
                  ปรับ RTP
                </argon-button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="7" class="text-center">ไม่พบข้อมูล</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
import EditModal from "../../views/components/EditModal.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Swal from "sweetalert2";
import { useRouter } from "vue-router";

export default {
  components: { EditModal, ArgonButton },
  name: "l-table",
  data() {
    return {
      searchQuery: "",
      sortBy: "name",
      sortOrder: 1,
      selectedUser: {},
      dataModal: false,
      typeModal: 0,
      startRow: 0,
      rowsPerPage: 100,
      currentPage: 1,
      data: [],
      allGame: [],
      isLoading: false,
      role: "",
      loading: false,
      excludedCodes: [
        "G001",
        "G002",
        "G003",
        "G004",
        "G005",
        "G006",
        "G008",
        "G009",
        "G010",
        "G014",
        "G015",
        "G056",
        "G081",
        "G090",
        "G091",
        "G092",
        "G093",
        "G097",
      ],
      buttons: [
        { type: 1, label: "ปรับทุกเกม" },
        { type: 2, label: "ปรับ 3x5" },
        { type: 3, label: "ปรับ 3x3" },
        { type: 4, label: "ปรับ 4x5" },
        { type: 5, label: "ปรับ 3600 Ways" },
        { type: 6, label: "ปรับ 243 Ways" },
        { type: 7, label: "ปรับ 720 Ways" },
        { type: 8, label: "ปรับ 7x7" },
      ],
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      agent: "",
      username: "",
    };
  },
  created() {
    this.getData();
    this.fetchUserRole();
  },
  computed: {
    filteredData() {
      const search = this.searchQuery.toLowerCase().trim();

      return this.data.filter((item) => {
        const matchesSearch =
          item.code?.toLowerCase().includes(search) ||
          item.name?.toLowerCase().includes(search) ||
          item.name_th?.toLowerCase().includes(search);

        return !search || matchesSearch;
      });
    },
    displayedData() {
      return this.filteredData.slice(
        this.startRow,
        this.startRow + this.rowsPerPage
      );
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.rowsPerPage);
    },
  },
  methods: {
    openModal(type, item = null) {
      this.typeModal = type;
      if ([1, 2, 3, 4, 5, 6, 7].includes(type)) {
        if (type === 1) {
          this.allGame = this.data.filter((game) => game.reel_type_id != 0);
        } else if (type === 2) {
          this.allGame = this.data.filter((game) => game.reel_type_id === 1 || game.reel_type_id === 2);
        } else if (type === 3) {
          this.allGame = this.data.filter((game) => game.reel_type_id === 3);
        } else if (type === 4) {
          this.allGame = this.data.filter((game) => game.reel_type_id === 4);
        } else if (type === 5) {
          this.allGame = this.data.filter((game) => game.reel_type_id === 5);
        } else if (type === 6) {
          this.allGame = this.data.filter((game) => game.reel_type_id === 6);
        } else if (type === 7) {
          this.allGame = this.data.filter((game) => game.reel_type_id === 7);
        }
        this.selectedUser = {};
      } else {
        this.allGame = [];
        this.selectedUser = item || {};
      }
      this.dataModal = true;
    },
    handleModalClose() {
      this.typeModal = 0;
      this.selectedUser = {};
      this.allGame = [];
      this.dataModal = false;
      this.getData();
    },
    sort(sortBy) {
      if (this.sortBy === sortBy) {
        this.sortOrder = -this.sortOrder;
      } else {
        this.sortBy = sortBy;
        this.sortOrder = 1;
      }
      this.data.sort((a, b) => {
        if (a[sortBy] > b[sortBy]) return this.sortOrder;
        if (a[sortBy] < b[sortBy]) return -this.sortOrder;
        return 0;
      });
    },
    getClass(rtpId) {
      switch (rtpId) {
        case 1:
          return "rtp1";
        case 2:
          return "rtp2";
        case 3:
          return "rtp3";
        case 4:
          return "rtp4";
        default:
          return "rtp5";
      }
    },
    itemValue(item, column) {
      if (column === "reel_type_id") {
        switch (item.reel_type_id) {
          case 1:
            return "3 x 5 Stack Wild";
          case 2:
            return "3 x 5 Random Wild";
          case 3:
            return "3 x 3";
          case 4:
            return "4 x 5";
          case 5:
            return "3600 ways";
          case 6:
            return "243 ways";
          case 7:
            return "720 ways";
          case 8:
            return "7 x 7";
          default:
            return "";
        }
      } else if (column === "rtp_id") {
        switch (item.rtp_id) {
          case 1:
            return "แตก 80.00%";
          case 2:
            return "แตก 96.50%";
          case 3:
            return "แตก 120.00%";
          case 4:
            return "แตก 150.00%";
          case 5:
            return "แตก 90.00%";
          default:
            return "";
        }
      }
      return item[column];
    },
    getData() {
      this.isLoading = true;
      axios
        .post(`https://dashboard-api.linkstudio.io/api/v1/game/control/gameconfig`)
        .then((response) => {
          this.data = response.data.data.list.filter((game) => game.active === true);
          this.allGame = this.data;
          this.isLoading = false;
        })
        .catch((e) => {
          console.error(e);
          Swal.fire({
            icon: "error",
            title: "ไม่สามารถดึงข้อมูลได้",
            text: e.response?.data?.responseStatus?.message || e.message
          });
          this.isLoading = false;
        });
      this.currentPage = 1;
      this.startRow = 0;
    },
    fetchUserRole() {
      axios
        .get("https://dashboard-api.linkstudio.io/api/v1/game/control/users/me", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((res) => {
          this.role = res.data.data.role || "";
        })
        .catch((e) => {
          console.log(e)
          Swal.fire({
            icon: "error",
            title: "ไม่สามารถระบุสิทธิ์ผู้ใช้ได้",
            text: "กรุณาเข้าสู่ระบบใหม่",
          }).then(() => {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            localStorage.removeItem("username");
            localStorage.removeItem("lastActivity");
            this.$router.push("/signin");
          });
          this.role = "";
        });
    },
  },
};
</script>

<style scoped>
@media (max-width: 576px) {
  input.form-control {
    font-size: 0.9rem;
  }
  .table th, .table td {
    font-size: 0.85rem;
    padding: 0.3rem 0.5rem;
  }
  argon-button .btn {
    font-size: 0.85rem;
    padding: 0.5rem;
  }
}
.hover-highlight:hover {
  background-color: #456f9a;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.rtp1 { color: grey; }
.rtp2 { color: yellowgreen; }
.rtp3 { color: green; }
.rtp4 { color: blue; }
.rtp5 { color: red; }
</style>